import { render, staticRenderFns } from "./ziXingBianXi.vue?vue&type=template&id=2056c86b&scoped=true&"
import script from "./ziXingBianXi.vue?vue&type=script&lang=js&"
export * from "./ziXingBianXi.vue?vue&type=script&lang=js&"
import style0 from "./ziXingBianXi.vue?vue&type=style&index=0&id=2056c86b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2056c86b",
  null
  
)

export default component.exports